<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @handleSubmit="handleSubmit" @exportFile="exportFile"></searchForm>
		<Row :gutter="10" style="margin-bottom: 10px;">
			<Col span="12">
			<Card class="card">
				<template #title>即时({{$refs.MyTerm.formInline.TimeBegin}}至{{$refs.MyTerm.formInline.TimeEnd}})</template>
				<Row>
					<Col span="12">
					<div><span class="text">即时支付金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.PrepayRecharge.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">即时消费金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.PrepayConsume.toFixed(2)}}</span></div>
					</Col>
				</Row>
				<Row>
					<Col span="12">
					<div><span class="text">即时退款金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.PrepayRefund.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">即时冻结金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.PrepayFreeze.toFixed(2)}}</span></div>
					</Col>
				</Row>
			</Card>
			</Col>
			<Col span="12">
			<Card class="card">
				<template #title>钱包({{$refs.MyTerm.formInline.TimeBegin}}至{{$refs.MyTerm.formInline.TimeEnd}})</template>
				<Row>
					<Col span="12">
					<div><span class="text">钱包支付金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.WalletRecharge.toFixed(2)}}</span></div>
					</Col>
					<Col>
					<div><span class="text">钱包消费金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.WalletConsume.toFixed(2)}}</span></div>
					</Col>
				</Row>
				<Row>
					<Col span="12">
					<div><span class="text">钱包退款金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.WalletRefund.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">钱包冻结金额(元)：</span><span
							class="value">{{memberStatisticsPeriod.WalletFreeze.toFixed(2)}}</span></div>
					</Col>
				</Row>
			</Card>
			</Col>
		</Row>
		<Table :columns="columns1" :data="data" :height="tableHeight" ref="tableData" size="small"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getTransactionRecordInfoUrl" @listData='getDeviceData'>
		</MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './TransactionRecordInfoComponent/searchForm.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm
		},
		data() {
			return {
				getTransactionRecordInfoUrl: webapi.base_api_url + '/Member/GetTransactionRecordInfo',
				memberStatisticsPeriod: {
					PrepayRecharge: 0,
					PrepayConsume: 0,
					PrepayRefund: 0,
					PrepayFreeze: 0,
					WalletRecharge: 0,
					WalletConsume: 0,
					WalletRefund: 0,
					WalletFreeze: 0,
				},
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['个人会员', '>>', '会员交易信息'],
				//table标题数据
				columns1: [{
						title: '交易时间',
						key: 'TransactionTime',
					}, {
						title: '充电卡号/VIN',
						key: 'CardNo',
					},
					// {
					// 	title: '会员Id',
					// 	key: 'MemberId',
					// 	width: 100
					// }, 
					{
						title: '会员名称',
						key: 'MemberName',
					},
					{
						title: '手机号码',
						key: 'PhoneNo',
					},
					// {
					// 	title: '交易状态',
					// 	key: 'TransactionStatus',
					// 	width: 120
					// },
					{
						title: '交易金额(元)',
						key: 'TransactionAmount',
					},
					{
						title: '交易前余额(元)',
						key: 'TransactionBalanceBefore',
					},
					{
						title: '交易后余额(元)',
						key: 'TransactionBalanceAfter',
					},
					{
						title: '交易类型',
						key: 'TransactionType',
						render: (h, params) => {
							// let type = '';
							// switch(params.row.TransactionType){
							// 	case 1:
							// 	type="充值"
							// 	break;
							// 	case 2:
							// 	type="退款"
							// 	break;
							// 	case 3:
							// 	type="消费"
							// 	break;
							// 	case 4:
							// 	type="赠送"
							// 	break;
							// }
							return h('div', params.row.TransactionTypeDesc);
						},
					},
					// {
					// 	title: '交易来源',
					// 	key: 'TransactionSource',
					// 	width: 200
					// },
					{
						title: '平台订单号',
						key: 'TransactionOrderNo',
						width: 250
					},
					// {
					// 	title: '交易内容',
					// 	key: 'TransactionContent',
					// 	width: 200
					// },
					// {
					// 	title: '商户订单号',
					// 	key: 'TransactionTradeNo',
					// 	width: 200
					// },
					// {
					// 	title: '充电记录ID',
					// 	key: 'TransactionBalanceBefore',
					// 	width: 200
					// },
					// {
					// 	title: '充电流水号',
					// 	key: 'ChargeSerialNo',
					// 	width: 200
					// },
					// {
					// 	title: '操作者',
					// 	key: 'Operator',
					// 	width: 200
					// },
				],
				data: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 360;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: '会员交易记录',
					columns: this.columns1,
					data: this.data.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.TransactionOrderNo = "\t" + k.TransactionOrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.State = k.StateDesc;
						k.TransactionType = k.TransactionTypeDesc;
						return k;
					})
				})
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			/******************组件固定方法*************************/
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Member/GetMemberStatisticsPeriod ", _this.$refs.MyTerm
					.formInline, {}).then(
					res => {
						if (res.data.Code == 0) {
							// _this.$Message.success('请求成功');
							_this.memberStatisticsPeriod = res.data.Data;
						} else {
							_this.$Message.error('请求失败');
						}
					}).catch(err => {
					_this.$Message.error('请求失败');
				});
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 360;
			},
		},
	}
</script>

<style scoped>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */
	#app {
		text-align: left;
	}

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.ivu-card-head::before {
		content: '⊱⊱ ';
		color: lightskyblue;
	}

	.ivu-card-head::after {
		content: ' ⊰⊰';
		color: lightskyblue;
	}

	.summy .text,
	.card .text {
		font-size: 16px;
	}

	.card .value {
		font-size: 18px;
		/* color: royalblue; */
	}
</style>
